import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["menuList", "popupClassName"];
import { isVNode as _isVNode, createVNode as _createVNode } from "vue";
function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      var F = function F() {};
      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true,
    didErr = false,
    err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import { defineComponent, ref, computed, watch, onMounted } from 'vue';
import { useStyleConfig } from '../abstract';
import RouterMenuItem from './RouterMenuItem';
import { Menu } from 'ant-design-vue';
import { menuProps } from 'ant-design-vue/es/menu/src/Menu';
import { useRoute, useRouter } from 'vue-router';
import { useModelValue } from '../vc-utils';
/**
 * 从路由获取菜单数据
 * @param router
 * @param basePath
 */
function _isSlot(s) {
  return typeof s === 'function' || Object.prototype.toString.call(s) === '[object Object]' && !_isVNode(s);
}
export function getRouterMenus(router, basePath) {
  var menuList = getMenuFromRoutes(router.options.routes);
  formatPath(menuList);
  return filterMenu(findChildren(menuList, basePath));
}
/**
 * 从路由解析菜单数据
 * @param routes
 */
export function getMenuFromRoutes(routes) {
  return routes
  // .filter((route) => route.meta?.renderMenu ?? true)
  .map(function (route) {
    var _ref, _meta$title, _route$meta$renderMen, _route$meta;
    var name = route.name,
      meta = route.meta,
      path = route.path,
      children = route.children;
    return {
      path: path,
      title: (_ref = (_meta$title = meta === null || meta === void 0 ? void 0 : meta.title) !== null && _meta$title !== void 0 ? _meta$title : name) !== null && _ref !== void 0 ? _ref : path,
      key: path,
      meta: _objectSpread(_objectSpread({}, meta !== null && meta !== void 0 ? meta : {}), {}, {
        visible: (_route$meta$renderMen = (_route$meta = route.meta) === null || _route$meta === void 0 ? void 0 : _route$meta.renderMenu) !== null && _route$meta$renderMen !== void 0 ? _route$meta$renderMen : true
      }),
      children: children && getMenuFromRoutes(children)
    };
  });
}
/**
 * 格式化 path，把相对 path 格式化为 绝对 path
 * @param menuList
 * @param parent
 */
function formatPath(menuList) {
  var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  menuList.forEach(function (item) {
    var _item$children;
    item.path = item.path.startsWith('/') ? item.path : parent + '/' + item.path;
    item.path = item.path.replace(/\/\//g, '/');
    item.key = item.path;
    if (((_item$children = item.children) === null || _item$children === void 0 ? void 0 : _item$children.length) > 0) {
      formatPath(item.children, item.path);
    }
  });
}
/**
 * 根据 path 查找子菜单
 * @param routes
 * @param path
 */
export function findChildren(menuList, path) {
  if (!path) {
    return menuList;
  }
  var _iterator = _createForOfIteratorHelper(menuList),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var menu = _step.value;
      if (menu.path === path) {
        var _menu$children;
        return (_menu$children = menu.children) !== null && _menu$children !== void 0 ? _menu$children : [];
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  var _iterator2 = _createForOfIteratorHelper(menuList),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _menu$children2;
      var _menu = _step2.value;
      if (((_menu$children2 = _menu.children) === null || _menu$children2 === void 0 ? void 0 : _menu$children2.length) > 0) {
        var _menuList = findChildren(_menu.children, path);
        if (_menuList) {
          return _menuList;
        }
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return [];
}
/**
 * 查找所有祖先级key
 * @param matchedPath
 * @param menuData
 * @param keys
 */
export function findParentKeys(path, menuList) {
  var keys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var _iterator3 = _createForOfIteratorHelper(menuList),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var _menu$children3;
      var menu = _step3.value;
      if (path === menu.path) {
        return keys;
      } else if (((_menu$children3 = menu.children) === null || _menu$children3 === void 0 ? void 0 : _menu$children3.length) > 0) {
        var matchedKeys = findParentKeys(path, menu.children, [].concat(_toConsumableArray(keys), [menu.path]));
        if (matchedKeys.length > 0) {
          return matchedKeys;
        }
      }
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  return [];
}
/**
 * 根据 path 映射为菜单 map
 * @param menuList
 * @param map
 */
function toMenuMap(menuList) {
  var map = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  menuList.forEach(function (menu) {
    map[menu.path] = menu;
    if (menu.children) {
      toMenuMap(menu.children, map);
    }
  });
  return map;
}
/**
 * 过滤菜单
 * @param menuList
 */
function filterMenu(menuList) {
  return menuList.filter(function (menu) {
    var _menu$meta$visible, _menu$meta;
    return (_menu$meta$visible = (_menu$meta = menu.meta) === null || _menu$meta === void 0 ? void 0 : _menu$meta.visible) !== null && _menu$meta$visible !== void 0 ? _menu$meta$visible : true;
  }).map(function (menu) {
    var _menu$children4;
    if (((_menu$children4 = menu.children) === null || _menu$children4 === void 0 ? void 0 : _menu$children4.length) > 0) {
      menu.children = filterMenu(menu.children);
    }
    return menu;
  });
}
export default defineComponent({
  name: 'RouterMenu',
  props: _objectSpread(_objectSpread({}, menuProps()), {}, {
    popupClassName: String,
    basePath: {
      type: String
    },
    menuList: Array
  }),
  emits: ['update:selectedKeys', 'update:openKeys'],
  setup: function setup(props, ctx) {
    var router = useRouter();
    var route = useRoute();
    var _useStyleConfig = useStyleConfig('router-menu'),
      prefixCls = _useStyleConfig.prefixCls;
    var sMenuList = computed(function () {
      if (props.menuList) {
        formatPath(props.menuList);
        return filterMenu(props.menuList);
      }
      return getRouterMenus(router, props.basePath);
    });
    // 选中的菜单
    var _useModelValue = useModelValue(function () {
        return props.selectedKeys;
      }, function (val) {
        ctx.emit('update:selectedKeys', val);
      }),
      sSelectedKeys = _useModelValue.value;
    // 展开的菜单
    var _useModelValue2 = useModelValue(function () {
        return props.openKeys;
      }, function (val) {
        ctx.emit('update:openKeys', val);
      }),
      sOpenKeys = _useModelValue2.value;
    // 展开菜单缓存
    var openKeysCache = ref([]);
    function updateState(route) {
      if (route) {
        var matchList = route.matched;
        sSelectedKeys.value = matchList.map(function (item) {
          return item.path;
        });
        var matchedKeys = sSelectedKeys.value.filter(function (item) {
          return item !== '';
        });
        matchedKeys.pop();
        if (!props.inlineCollapsed && props.mode === 'inline') {
          sOpenKeys.value = matchedKeys;
        } else {
          openKeysCache.value = matchedKeys;
        }
      }
    }
    watch(function () {
      return props.inlineCollapsed;
    }, function (collapsed) {
      if (collapsed) {
        openKeysCache.value = _toConsumableArray(sOpenKeys.value);
        sOpenKeys.value = [];
      } else {
        sOpenKeys.value = _toConsumableArray(openKeysCache.value);
      }
    });
    watch(function () {
      return props.mode;
    }, function (mode) {
      if (!props.inlineCollapsed && mode === 'inline') {
        sOpenKeys.value = _toConsumableArray(openKeysCache.value);
      }
    });
    watch(route, function (_route) {
      updateState(_route);
    });
    onMounted(function () {
      return updateState(route);
    });
    return {
      prefixCls: prefixCls,
      sSelectedKeys: sSelectedKeys,
      sOpenKeys: sOpenKeys,
      sMenuList: sMenuList,
      openKeysCache: openKeysCache
    };
  },
  render: function render() {
    var _this = this;
    var props = this.$props,
      sSelectedKeys = this.sSelectedKeys,
      sOpenKeys = this.sOpenKeys,
      sMenuList = this.sMenuList,
      prefixCls = this.prefixCls;
    var _ = props.menuList,
      popupClassName = props.popupClassName,
      menuProps = _objectWithoutProperties(props, _excluded);
    var menuItemList = sMenuList.map(function (item) {
      return _createVNode(RouterMenuItem, {
        "config": item,
        "popupClassName": popupClassName
      }, null);
    });
    return _createVNode(Menu, _objectSpread(_objectSpread({}, menuProps), {}, {
      "selectedKeys": sSelectedKeys,
      "openKeys": sOpenKeys,
      "class": prefixCls,
      'onUpdate:openKeys': function onUpdateOpenKeys(keys) {
        return _this.sOpenKeys = keys;
      }
    }), _isSlot(menuItemList) ? menuItemList : {
      default: function _default() {
        return [menuItemList];
      }
    });
  }
});